/**
* 系统管理 角色管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>合伙人订单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">



      <el-form-item label="公司" prop="investorId">
        <el-select v-model="investorId" placeholder="请选择" size="medium">
          <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit1()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
      element-loading-text="拼命加载中" style="width: 100%;">

      <!--      <el-table-column prop="createTime" label="创建时间">
      </el-table-column> -->
      <el-table-column align="investorId" label="出资公司">
        <template slot-scope="scope">
          <div v-if="scope.row.investorId==1">北京亿嗨金城网络技术有限公司</div>
          <div v-if="scope.row.investorId==3">北京亿嗨曲江网络技术有限公司</div>
          <div v-if="scope.row.investorId==4">海南亿荣纬业企业管理中心合伙企业（有限合伙）</div>
        </template>
      </el-table-column>
      <el-table-column prop="startDate" label="开始时间">
      </el-table-column>
      <el-table-column prop="endDate" label="结束时间">
      </el-table-column>

      <el-table-column prop="orderCount" label="订单数">
      </el-table-column>
      <el-table-column prop="profitAmount" label="收益金额">
      </el-table-column>

    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!-- 编辑界面 -->
    <el-dialog title="新增合伙人订单数据" :visible.sync="menuAccessshow" @click='closeDialog("perm")'>
      <el-form label-width="120px" :model="editForm1" ref="editForm">


        <el-form-item label="公司" prop="investorId">
          <el-select v-model="editForm1.investorId" placeholder="请选择" size="small">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始-结束日期" prop="systemNo">
          <el-date-picker v-model="value1" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
          <!--        <div>2022-04-01 2022-04-07
            一周的开始时间和结束时间
          </div> -->
        </el-form-item>
        <el-form-item label="订单数量" prop="systemNo">
          <el-input size="small" v-model="editForm1.orderCount" auto-complete="off" placeholder="订单数量"></el-input>
        </el-form-item>
        <el-form-item label="收益金额" prop="roleName">
          <el-input size="small" v-model="editForm1.profitAmount" auto-complete="off" placeholder="收益金额"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm1('tj')">添加
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    getInvestorProfitPage,
    createPartnershipDate,
    investorCompany
  } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        nshow: true, //switch开启
        fshow: false, //switch关闭
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        menuAccessshow: false, //控制数据权限显示与隐藏
        title: '添加',
        editForm: {
          roleId: '',
          menuIds: '',
        },
        editForm1: {
          name: '',
          description: '',
          investorId: '',
        },
        options: [

          {
            label: '北京亿嗨金城网络技术有限公司',
            value: 1
          }, {
            label: '北京亿嗨曲江网络技术有限公司',
            value: 3
          }, {
            label: '海南亿荣纬业企业管理中心合伙企业（有限合伙）',
            value: 4
          },
        ],
        options1: [

          {
            label: '全部',
            value: ''
          }, {
            label: '北京亿嗨金城网络技术有限公司',
            value: 1
          }, {
            label: '北京亿嗨曲江网络技术有限公司',
            value: 3
          }, {
            label: '海南亿荣纬业企业管理中心合伙企业（有限合伙）',
            value: 4
          },
        ],
        investorId: '',
        listData1: [

        ],
        value1: '',
        formInline: {
          page: 1,
          limit: 20,
          varLable: '',
          varName: '',
          token: localStorage.getItem('logintoken')
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 20,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },


    watch: {},



    created() {
      this.getdata(this.formInline)
    this.investorCompany()
    },
    
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
    
    
      investorCompany() {
        let pro = {
          "userId": JSON.parse(localStorage.getItem('userdata')).muId,
        }
        investorCompany(pro).then(res => {
          this.options = res.data
          this.options1 = res.data
           this.options1.unshift( {
            label: '全部',
            value: ''
          })
        })
      },
      getdata(parameter) {
        this.loading = true
        let pro = {
            "page": parameter.page,
            "pageSize": parameter.limit,

            investorId: this.investorId,
            "startDate": '',
            endDate: '',
        }
        getInvestorProfitPage(pro)
          .then(res => {
            this.loading = false
            if (res.code == 1) {
              this.$message({
                type: 'info',
                message: res.baseInfo.msg
              })
            } else {
              this.listData = res.data.data.list
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.limit
              this.pageparm.total = res.data.data.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('获取列表失败，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.getdata(this.formInline)
      },
      //显示编辑界面
      handleEdit: function(index, row) {
        this.editFormVisible = true
        if (row != undefined && row != 'undefined') {
          this.yhRoleAuthArr(row.id)
          this.title = row.name
          this.editForm.roleId = row.id
        }
      },
      handleEdit1: function(index, row) {
        this.menuAccessshow = true
      },

      submitForm1(editData) {
        console.log(this.value1)
        let pro = {
          "userId": JSON.parse(localStorage.getItem('userdata')).muId,
            "profitAmount": this.editForm1.profitAmount,
            "orderCount": this.editForm1.orderCount,
            investorId: this.editForm1.investorId,
            "startDate": this.value1[0],
            "endDate": this.value1[1]

        }

        createPartnershipDate(pro)
          .then(res => {
            this.menuAccessshow = false
            this.loading = false
            if (res.code == 1) {
              this.$message({
                type: 'info',
                message: res.baseInfo.msg
              })
            } else {
              this.$message({
                type: 'success',
                message: '添加成功！'
              })
              this.getdata(this.formInline)
              this.value1 = ''
              this.editForm1 = {
                profitAmount: '',
                orderCount: '',
              }
            }
          })

      },




      // 关闭编辑、增加弹出框
      closeDialog(dialog) {

        this.menuAccessshow = false
        this.value1 = ''
        this.editForm1 = {
          profitAmount: '',
          orderCount: '',
        }
      }
    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/partner/partner.vue